<template>
  <div>
    <slot/>
  </div>
</template>

<script setup>
import Highcharts from "@/highcharts"
import { onMounted } from "vue"

const props = defineProps({
  data: Array,
})

const createSeries = (key, name, color) => ({
  data: props.data.filter(row => !!row[key]).map(row => [row.year, row[key]]),
  marker: { enabled: false, symbol: "circle" },
  color,
  name,
  dataLabels: {
    enabled: true,
    y: 8,
    formatter() {
      if (this.point.index == 2) {
        return this.series.name
      }
    },
    borderRadius: 3,
    backgroundColor: "rgba(0,0,0,.4)",
    borderWidth: 1,
    borderColor: "#CCC",
    color: "#FFF",
  },
})

onMounted(() => {
  const options = {
    chart: { type: "area" }, title: { text: "" }, yAxis: { min: 0, max: 100, labels: { enabled: false }, title: { text: "" } }, plotOptions: { series: { stacking: "percent" } }, exporting: { enabled: false },
    credits: { enabled: false },
    xAxis: { minPadding: 0, maxPadding: 0, endOnTick: false, tickInterval: 2, labels: { rotation: -45, align: "right" }, crosshair: true },
    tooltip: {
      shared: true,
      formatter() {
        let s = `<b>${this.x}</b>`
        $.each(this.points, function () {
          s += `<br/><span style="color:${this.color}">\u25CF</span> ${this.series.name}: <b>${
            Math.round(this.percentage * 10) / 10}%</b>`
        })

        return s
      },
    },
    legend: { enabled: false },
  }

  new Highcharts.chart("stacked_timing", {
    ...options,
    series: [
      createSeries("timing_afterGrad", "After Graduation", "#bac8ff"),
      createSeries("timing_beforeGrad", "Before Graduation", "#748ffc"),
    ],
  })

  new Highcharts.chart("stacked_status", {
    ...options,
    series: [
      createSeries("search_seeking", "Seeking", "#bac8ff"),
      createSeries("search_notSeeking", "Not Seeking", "#748ffc"),
    ],
  })

  new Highcharts.chart("stacked_source", {
    ...options,
    series: [
      createSeries("source_networking_total", "Networking", "#bac8ff"),
      createSeries("source_posting_total", "Job Posting", "#bac8ff"),
      createSeries("source_oci_total", "On-Campus Interview", "#bac8ff"),
      createSeries("source_experience", "Experience", "#748ffc"),
      createSeries("source_priorJob", "Prior Job", "#748ffc"),
      createSeries("source_startedFirm", "Started Firm", "#748ffc"),
      createSeries("source_other_total", "Other", "#748ffc"),
    ],
  })
})
</script>
